module.exports = __webpack_public_path__ + "static/media/animalworld.4c7c2aac.mp3";